// extracted by mini-css-extract-plugin
export var truncate = "_o-0";